// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"626":"b09be5c3","910":"bf9e499e"}[chunkId] + ".chunk.css";
};